import React, { useState } from 'react';
import {
  BrowserRouter,
  Link,
  Route,
  Routes,
} from "react-router-dom";

import Heatmap from "./components/Heatmap/ReactHeatmap";
import Options from "./components/Options";
import Tool from './Tool';
import Paper from './Paper';

// import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Tool/>} />
        <Route path='/paper' element={<Paper/>}/>
        <Route path='*' element={<div>Page does not exist</div>}/>
      </Routes>
    </BrowserRouter>
  )
}